export default __webpack_public_path__ + "static/media/background-header.707432ae.svg";